// REACT
import React from "react";

// MATERIAL-UI
import { Grid } from "@mui/material";

// ASSETS
import { CommonStyles } from "./common.styles";
import { CommonProps } from "./types";

const Container = (props: CommonProps) => {
  const classes = CommonStyles();

  const customStyles = React.useMemo(() => {
    if (!props.config) return {};

    return {
      padding: props.config.padding || "",
      borderRadius: props.config.borderRadius || "",
      backgroundColor: props.config.backgroundColor || "",
    };
  }, [props.config]);

  return (
    <Grid
      container
      className={props.className ? props.className : classes.container}
      style={customStyles}
    >
      {props.children}
    </Grid>
  );
};

export default Container;
